import React, { Component } from 'react';
import PagesForm from '../PagesForm/Container'
import Modal from '../Modal'
import { Uploader, UploadField } from '@navjobs/upload'
import {serverUrl} from '../../utils/restUtils'
import './pages.css'
import ReactTooltip from 'react-tooltip'
class Home extends Component {


    constructor(props){
	super(props)
	this.state = {modalVisible: null}
    }
    
    componentDidMount(){
	this.props.loadPages();
    }

    
    render() {
	const {pages, removePage, updatePage, loadPages} = this.props
	const {modalVisible} = this.state
	const toggleModal = (data) => {

	    let {modalVisible} = this.state
	    modalVisible = data
	    this.setState({modalVisible})
	}
	return (

	    <div>
		
		<h1>Administracija strani</h1>

		<button className="btn btn-brown btn-big full-width" onClick={() => toggleModal({})}><i className="fa fa-plus"></i> Dodaj stran</button>

		<table className="table-striped pages">
		    <thead>
			<tr><th>Slika</th><th>Naslov</th><th>Categorija</th></tr>
		    </thead>
		    <tbody>
			{
			    pages ?
			    pages.map((page, index) =>
				<tr key={index}>
				    <td style={{width: '250px'}}>
					<div style={{width: '250px'}}>
					    <Uploader
						request={{
						    fileName: 'file',
						    url: serverUrl()+'/pages/'+page.id+'/image_upload',
						    method: 'PUT',
						    withCredentials: true
						}}
						onComplete={({ response, status }) => {
						    loadPages()
						}}
						uploadOnSelection={true}
					    >
						{({ onFiles, progress, complete }) => (
						    <div className="adminSection">
							<ReactTooltip />
							<button className="btn"  data-tip="Postavi na glavno stran" style={{float: 'left', color: (page.is_main ? 'green' : 'red')}} onClick={() => updatePage({id: page.id, is_main: !page.is_main })}><i className="fa fa-star"></i></button>
							<button className="btn" data-tip="Spremeni" style={{float: 'left'}} onClick={() => toggleModal(page)}><i className="fa fa-edit"></i></button>
							<button className="btn"  data-tip="Zbriši" style={{float: 'right'}} onClick={() => removePage(page)}><i className="fa fa-remove"></i></button>
							
							<div  style={{float: 'left'}} data-tip="Dodaj ali menjaj sliko">
							    <UploadField onFiles={files => {
								if(Array.from(files).map(f => f.size>100*1024*1024 ).filter(x => x ).length === 0)
								    onFiles(files)
								else
								    alert('preveč velik file, max 100MB')
							    } }  uploadProps={{ accept: '.png,.jpg,.jpeg,.svg,.gif'}}>
								<button className="btn">
								    <i className="fa fa-camera"></i>
								</button>
							    </UploadField>
							</div>
							<div style={{clear: 'both'}}></div>
							{!complete && progress  ?
							 <div className="progressBar">
							     <div style={{width: progress+'%'}}></div>
							 </div>
							: null}

						    </div>
						)}
					    </Uploader>

					    <img src={page.image_id ? serverUrl()+'/images/'+page.image_id : '/images/noimage.png'} alt={page.title} style={{width: '250px'}} />
					</div>
					
				    </td>
				    <td><h2>{page.title}</h2></td>
				    <td>{page.section}</td>
				    
				    

				</tr>
			    )
			    :
			    null
			}
		    </tbody>
		</table>

		
		
		<Modal toggleModal={() => toggleModal(false)} visible={modalVisible}>
		    <h2>Dodaj stran</h2>
		    <PagesForm successAction={toggleModal}  initialValues={modalVisible} />
		</Modal>
	    </div>
	);
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Pages/index.jsx